/* eslint-disable */
import dayjs from "dayjs";
import { Button, TextField, Dialog, Autocomplete } from "@mui/material";
import { useState } from "react";
import { usePermissionStore } from "../../../stores/permissionStore";
import useSubmit from "./useSubmit";
import Text from "../../../components/atoms/Text";
import { actionType } from "./constants";

const DeductPointsDialog = ({
  dataRewardStoreType,
  isShow,
  omneId,
  handleClose,
  activityTypeName,
  rewardTypeName,
  userRewardId,
  userRedemptionId,
  mode,
  dateTime,
  points,
}) => {
  const [rewardId, setRewardId] = useState("");
  const [inputPoints, setInputPoints] = useState("");
  const [remark, setRemark] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);

  const resetData = () => {
    setRewardId("");
    setInputPoints("");
    setRemark("");
    setDisableSubmit(false);
  };

  const { handleSubmitOnDeductPointsDialog: handleSubmit } = useSubmit({
    omneId,
    rewardId,
    points: inputPoints,
    remark,
    userRewardId,
    userRedemptionId,
    mode,
    handleClose,
    resetData,
    setDisableSubmit,
    permission_Token: usePermissionStore.getState().permissionToken ?? "",
  });

  const handleInputRemark = e => setRemark(e.target.value);

  const renderRewardTypeDDL = () => {
    if (mode === actionType.DEDUCT) {
      if (Array.isArray(dataRewardStoreType?.data)) {
        return (
          <Autocomplete
            disablePortal
            options={dataRewardStoreType.data}
            sx={{ width: 380 }}
            getOptionLabel={option => `${option.rewardId}__${option.title}`}
            renderInput={params => (
              <TextField {...params} label="Reward Type" />
            )}
            onChange={(event, newValue) => {
              setRewardId(newValue?.rewardId);
            }}
            style={{ marginBottom: 20 }}
          />
        );
      }
    }
  };

  const renderRemarkField = () => {
    if (mode === actionType.EDIT) {
      return null;
    } else if (mode === actionType.DEDUCT) {
      return <TextField label="Remarks" onBlur={handleInputRemark} />;
    }
  };

  const renderTitle = () => {
    switch (mode) {
      case actionType.DEDUCT:
        return "Deduct Points - Create";
      case actionType.EDIT:
        return "Deduct Points - Edit";
    }
  };

  return (
    <>
      <Dialog open={isShow} onClose={handleClose}>
        <div style={{ padding: 40 }}>
          <Text variant="h3" style={{ paddingBottom: 20 }}>
            {renderTitle()}
          </Text>
          {mode === actionType.EDIT && (
            <>
              <Text>ID: {userRedemptionId || userRewardId}</Text>
              <br />
              <Text>
                Date/Time: {dateTime && dayjs(dateTime).format("DD/MM/YYYY")}
              </Text>
              <br />
              <Text>Category: {activityTypeName}</Text>
              <br />
              <Text>Item name: {rewardTypeName}</Text>
              <br />
            </>
          )}
          {renderRewardTypeDDL()}
          <TextField
            label="Points"
            style={{ marginBottom: 20 }}
            defaultValue={points}
            value={inputPoints}
            onChange={e => {
              const reg = /^[0-9]+$/;
              if (e.target.value) {
                if (reg.test(e.target.value)) {
                  setInputPoints(e.target.value);
                } else {
                  setInputPoints(inputPoints);
                }
              } else {
                setInputPoints("");
              }
            }}
          />
          {renderRemarkField()}
        </div>
        <Button
          disabled={disableSubmit}
          onClick={handleSubmit}
          style={{ borderRadius: 0, paddingTop: 10, paddingBottom: 10 }}
        >
          Confirm
        </Button>
      </Dialog>
    </>
  );
};

export default DeductPointsDialog;
